app.component("donorCornea", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/donorCornea/donorCornea.html",
	controller: "donorCorneaController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("donorCorneaController", [
	"$scope",
	function ($scope) {
		this.$onInit = function () {};

		$scope.punchSizeOptions = [
			{ value: "SIZE_6_00", name: "6.00" },
			{ value: "SIZE_6_25", name: "6.25" },
			{ value: "SIZE_6_50", name: "6.50" },
			{ value: "SIZE_6_75", name: "6.75" },

			{ value: "SIZE_7_00", name: "7.00" },
			{ value: "SIZE_7_25", name: "7.25" },
			{ value: "SIZE_7_50", name: "7.50" },
			{ value: "SIZE_7_75", name: "7.75" },

			{ value: "SIZE_8_00", name: "8.00" },
			{ value: "SIZE_8_25", name: "8.25" },
			{ value: "SIZE_8_50", name: "8.50" },
			{ value: "SIZE_8_75", name: "8.75" },

			{ value: "SIZE_9_00", name: "9.00" },
			{ value: "SIZE_9_25", name: "9.25" },
			{ value: "SIZE_9_50", name: "9.50" },
			{ value: "SIZE_9_75", name: "9.75" },

			{ value: "OTHER", name: "Other (specify)" },
		];

		$scope.preparationOptions = [
			{ value: "SURGEON_MANUAL_DISSECTION", name: "Surgeon manual dissection" },
			{ value: "SURGEON_PREPARATION", name: "Surgeon preparation" },
			{ value: "EYE_BANK_PRE_CUT", name: "Eye Bank pre-cut" },
			{ value: "EYE_BANK_PRE_STRIPPED", name: "Eye Bank Pre-Stripped" },
			{ value: "EYE_BANK_PRE_STRIPPED_PRE_LOADED", name: "Eye Bank Pre-Stripped & Pre-Loaded" },
		];

		$scope.orientationOptions = [
			{ value: "S_STAMP", name: '"S" Stamp' },
			{ value: "F_STAMP", name: '"F" Stamp' },
			{ value: "ASYMMETRIC_PERIPHERAL_CUTS", name: "Asymmetric Peripheral Cuts" },
			{ value: "NONE", name: "None" },
		]
	},
]);
